var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5101 3.59997L5.3001 12.29C4.9901 12.62 4.6901 13.27 4.6301 13.72L4.2601 16.96C4.1301 18.13 4.9701 18.93 6.1301 18.73L9.3501 18.18C9.8001 18.1 10.4301 17.77 10.7401 17.43L18.9501 8.73997C20.3701 7.23997 21.0101 5.52997 18.8001 3.43997C16.6001 1.36997 14.9301 2.09997 13.5101 3.59997Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1399 5.05005C12.5699 7.81005 14.8099 9.92005 17.5899 10.2",
    stroke: "#2E2E2E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 22H21.25",
    stroke: "#2E2E2E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9244f1ed4aed542101f3b74131abf962.svg";
export { ForwardRef as ReactComponent };